var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',{staticClass:"loading-meet-room"},[_c('img',{attrs:{"src":require("../../../public/assets/images/gif/Loading.gif"),"width":"212","height":"212","alt":""}})]):_vm._e(),(!_vm.loading && _vm.email)?_c('div',[_c('OTPLoginCpn',{attrs:{"prop_email":_vm.email},on:{"logged":_vm.logged}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }